export default __webpack_public_path__ + "assets/images/ee3ae8d044f8f5a097f7bf820e073b1f.svg";